<template>
    <div id="us-all-Journey-cart">
        <div v-if="loading" style="width: 100%;padding: 0px 25px;">Reisen werden geladen...</div>
        <div v-else style="width: 100%;padding: 0px 25px;">{{ JCarts.length }} Reise<span v-if="JCarts.length !== 1">n</span> gefunden.</div>

        <div v-for="(jc, a) in JCarts" :key="a" class="usJcart" @click="goToDetail(jc.id_jrn_journey)">
            <div class="us-journey-pic-container">
                <swiper :options="JCswiper" ref="JCswiper" style="width:100%;height:100%;">
                    <swiper-slide style="width:100%;height:100%;" v-for="(pic, b) in jc.images" :key="b" class="us-jrn-swipe-container">
                        <!-- <img :src="pic.link"> -->

                        <div class="us-journey-pic-img" v-bind:style="{ 'background-image': 'url(' + pic.link + ')' }"></div>
                        <div class="us-journey-pic-copyright">{{ pic.copyright }}</div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="us-journey-descptrion-container">
                <div class="us-journey-Cat1">{{ jc.title }}</div>
                <div class="us-journey-Cat2">{{ jc.subtitle }}</div>
                <div class="us-journey-Cat3"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

var interval
var intervalIntern
export default {
    computed: {
        ...mapState(["JourneyStore"]),
        JCarts(){
            let args = core.getPathArgs(["kategorie"]);
            
            return this.JourneyStore.filter(item => {
                try{
                    let kategorien = item.extras.find(extra => extra.type === 'Kategorien');
                    return JSON.parse(kategorien.text).indexOf(args.kategorie) !== -1;
                }catch(err){
                    return false;
                }
            });
        }
    },

    mounted() {
        this.getPicShow()
    },
    components: {},
    destroyed() {
        clearInterval(interval)
        clearInterval(intervalIntern)
    },
    data() {
        return {
            JCswiper: {
                direction: "horizontal",
                effect: "cube",
                // grabCursor: true,
                speed: 1000,
                loop: true,
                cubeEffect: {
                    shadow: true,
                    slideShadows: true,
                    shadowOffset: 20,
                    shadowScale: 0.8
                }
            },
            loading: false
        }
    },
    watch: {
        $route(to, from) {
            this.getPicShow()
        }
    },
    methods: {
        goToDetail(Jid) {
            core.navigate({ path: "/journeydetail/" + Jid })
        },
        getPicShow() {
            if (interval !== undefined) {
                clearInterval(interval)
            }
            var time = 10000
            var speed = 2000
            var delay = 250
            interval = setInterval(() => {
                if (intervalIntern !== undefined) {
                    clearInterval(intervalIntern)
                }
                var sl = 0
                intervalIntern = setInterval(() => {
                    this.$refs.JCswiper[sl].swiper.slideNext(speed, false)
                    sl++
                    if (sl == this.$refs.JCswiper.length) {
                        clearInterval(intervalIntern)
                    }
                }, delay)
            }, time)
        }
    }
}
</script>

<style lang="scss">
#us-all-Journey-cart {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-self: flex-end;
    align-items: center;
    justify-content: center;
}

.usJcart {
    min-width: 320px;
    min-height: 320px;
    width: 22vw;
    height: 22vw;
    position: relative;
    margin: 0.5vw;
    margin-bottom: 1.5vh;
    /* border-radius:5px; */
    /* box-sshadow: 0px 0px 10px 0px #979797; */
    /* border:1px solid  #979797;     */
}

.us-journey-descptrion-container {
    background: #8a8a8a;
    position: relative;
    width: 100%;
    height: 3vh;
    bottom: 0px;
    margin-top: 1.5vh;
    left: 0px;
    min-height: 100px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 0px #979797;
    cursor: pointer;
    /* border:1px solid  #979797;  */
}
.us-journey-pic-container {
    position: relative;
    top: 0px;
    left: 0px;
    overflow: visible;
    width: 100%;
    height: 65%;
    transition: all 1s;
    cursor: pointer;
}
.us-journey-pic-img {
    width: 100%;
    background-color: #fff;
    height: 100%;
    /* border:1px solid  #979797; */
    border-radius: 5px;
    box-shadow: 0px 0px 10px 0px #d8d8d8;
    transition: all 1s;
    background-repeat: no-repeat;
    background-size: cover;
}

.us-journey-name {
    position: absolute;
    bottom: 0.5vw;
    right: 0.5vw;
    z-index: 10;
    font-weight: bold;
    font-size: 1.5vw;
    width: 60%;
    text-align: right;
    color: #fff;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
}

.us-journey-Cat1 {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 20px);
    // min-width: 320px;
    // width: 21vw;
    overflow: hidden;
    position: absolute;
    top: 1.3vh;
    right: 0.5vw;
    font-size: 1.3vw;
    color: #fff;
    text-align: right;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
}
.us-journey-Cat2 {
    position: absolute;
    bottom: 0.8vh;
    right: 0.5vw;
    font-weight: bold;
    font-size: 1vw;
    color: #f8ab65;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
    text-align: right;
    padding-left: 1vw;
    white-space: nowrap;
    overflow: hidden;
    width: 90%;
    text-overflow: ellipsis;
}

.us-journey-pic-copyright {
    position: absolute;
    z-index: 20;
    bottom: 10px;
    left: 10px;
    color: #fff;
    font-size: 9px;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
}

.us-journey-pic-container:hover {
    box-shadow: 0px 0px 5px 0px #676767;
    transform: scale(0.9);
}

@media (max-width: 400px) {
    .us-journey-Cat1 {
        font-size: 6vw;
        top: 1.5vh;
        right: 3vw;
    }
    .us-journey-Cat2 {
        font-size: 6vw;
        bottom: 1.5vh;
        right: 3vw;
    }
}
@media (min-width: 400px) and (max-width: 600px) {
    .us-journey-Cat1 {
        font-size: 3vw;
        top: 2vh;
        right: 2vw;
    }
    .us-journey-Cat2 {
        font-size: 3vw;
        bottom: 2vh;
        right: 2vw;
    }
}
@media (min-width: 600px) and (max-width: 900px) {
    .us-journey-Cat1 {
        font-size: 2vw;
        top: 2vh;
        right: 2vw;
    }
    .us-journey-Cat2 {
        font-size: 2vw;
        bottom: 2vh;
        right: 2vw;
    }
}
</style>



